<template>
  <div>
    <!-- 轮播图 -->
    <swiper title="设备维修保养" :bannerList="bannerList"></swiper>

    <section class="d-flex align-items-center pt-4 pb-4" data-aos="fade-up">
      <div class="container">
        <div class="row">
          <div class="col">
            <picture>
              <source media="(max-width: 768px)" srcset="@/assets/img/md/equipmentRepair/repair.png">
              <source media="(min-width: 768px)" srcset="@/assets/img/lg/equipmentRepair/repair.png">
              <img src="@/assets/img/lg/equipmentRepair/repair.png"  class="image-width-100"/>
            </picture>
          </div>
        </div>
      </div>
    </section>

    <!-- 项目背景 -->
    <section class="d-flex align-items-center pt-4 pb-4 text-line-height-1" data-aos="fade-up">
      <div class="container">
        <main-title title="项目背景"></main-title>
        <p class="indentation title-sub">Netluc设备维修保养系统是基于外资企业(德资/美资)制造业成熟管 理经验所开发的一套可靠、融合、流程标准化和易用的设备保养维修系统 平台。
          我司拥有完全的自主知识产权和迭代更新能力。 它涵盖了</p>
        <retract-list :dataList="projectList"></retract-list>
      </div>
    </section>

    <!-- 产品亮点 -->
    <section class="d-flex align-items-center pt-4 pb-4 text-line-height-1" data-aos="fade-up">
      <div class="container">
        <main-title title="产品亮点"></main-title>
        <div class="indentation">
          <desc-list :dataList="lightSpotList"></desc-list>
        </div>
      </div>
    </section>

    <!-- 落地 -->
    <section class="d-flex align-items-center pt-4 pb-4 text-line-height-1" data-aos="fade-up">
      <div class="container">
        <main-title title="落地"></main-title>
        <retract-list :dataList="implementList"></retract-list>
      </div>
    </section>

    <!-- 用户画像功能点 -->
    <section class="d-flex align-items-center pt-4 pb-4" data-aos="fade-up">
      <div class="container">
        <h1 class="title-main text-align-center font-weight-bold pt-2 pb-4">用户画像功能点</h1>
        <div class="row pt-3 pb-3">
          <div class="col">
            <picture>
              <source media="(max-width: 768px)" srcset="@/assets/img/md/equipmentRepair/user-fun.png">
              <source media="(min-width: 768px)" srcset="@/assets/img/lg/equipmentRepair/user-fun.png">
              <img src="@/assets/img/lg/equipmentRepair/user-fun.png"  class="image-width-100"/>
            </picture>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Swiper from '@/components/Swiper.vue'
export default {
  name: 'EquipmentRepair',
  components: { Swiper },
  props: {},
  data() {
    return {
      bannerList: [
        { src: require("@/assets/img/common/caseList/equipmentRepair/banner1.png") },
        { src: require("@/assets/img/common/caseList/equipmentRepair/banner2.png") },
        { src: require("@/assets/img/common/caseList/equipmentRepair/banner3.png") },
      ],
      // 项目背景
      projectList: [
        '1、设备维修：搭建生产设备报修体系，以工单任务的形式加强设备维修工作 的及时性和有效性；搭建维修工单任务体系，形成基于设备/维修指标的完 整工程经验数据知识库。',
        '2、设备保养：搭建生产设备保养体系，以工单任务的形式加强设备保养工作 的及时性和有效性。',
        '3、设备管理驾驶舱：搭建设备状态跟踪体系，可展示各关键生产设备的实 时维修、保养动态及状态指标。'
      ],
      // 产品亮点
      lightSpotList: [
        {
          title: "可靠：",
          titleDetail:
            "和工厂现有权限体系打通(比如AD域控)，能提供多级权限控制，务完善的密码验证等安全措施；能提供统一身份认证，系统集成等接口。满足制造业封闭性网络安全管理，同时可以根据用户要求，混淆加密上传部分数据供其他互联网用户查询。",
        },
        {
          title: "融合: ",
          titleDetail:
            "可以跟企业现有的ERP和MES做好数据融通。大部分信息化条件的制造业工厂大都了部署了ERP和MES系统，但在设备维修保养这个环节是不通的。比如物料信息和订单信息在ERP，生产设备标准化信息在MES。当作设备保养维护维修的时候，主要依靠人工记录。而我司平台可以通过系统平台打通两方信息，实现ERP和MES到设备维修平台的信息统一。",
        },
        {
          title: "流程标准化: ",
          titleDetail:
            "通过系统平台打通一张维修单或保养单在产线工人、维修工(电气工程师、钳工等)、生产主管、工程维修主管之间的高效而统一的流转。",
        },
        {
          title: "易用: ",
          titleDetail:
            "结合多平台（移动端、网页端、大屏看板、第三方消息推送）、多用户（生产员工、维修员工、部门主管），实现信息互享、高度互联。",
        }
      ],
      // 落地
      implementList: [
        '1、在功能实现方面，设备维修保养系统覆盖了现阶段生产数字化中针对设备报修、维修、保养等核心需求；',
        '2、在用户体验方面，设备维修保养系统串联起PAD、PC、大屏看板、第三方消息推送，囊括了生产现场、部门办公室等多种使用场景。'
      ]
    };
  },
  computed: {},
  watch: {},
  methods: {

  },
  created() {

  },
  mounted() {

  },
}
</script>
<style scoped>
</style>